import React from "react";
import SEOHead from "../components/tools/SEOHead";
import MarketingShell, { useMarketingCopy } from "./MarketingShell";
import workspaceCopy from "./productWorkspaceCopy.json";
import "./CompanyNarrative.css";
import "./InternationalMarketing.css";

const seo = {
  en: { title: "Learnflow | AI study assistant for recordings, files, and links", description: "Capture recordings, files, and links in Learnflow. Ask questions grounded in your sources and turn what you collect into understanding." },
  zh: { title: "Learnflow | 面向录音、文件与链接的 AI 学习助手", description: "用 Learnflow 汇集录音、文件与链接，基于来源提问，把收集的内容变成真正理解的知识。" },
  ja: { title: "Learnflow | 録音・ファイル・リンクの AI 学習アシスタント", description: "Learnflow に録音、ファイル、リンクを集め、出典に基づいて質問し、集めた内容を理解につなげましょう。" },
};

export default function LearnflowPage() {
  const { language } = useMarketingCopy();
  const copy = (workspaceCopy[language] ?? workspaceCopy.en).learnflow;
  const meta = seo[language] ?? seo.en;
  return <MarketingShell active="learnflow">
    <SEOHead title={meta.title} description={meta.description} canonicalUrl="https://youwo.ai/learnflow" ogImage="https://youwo.ai/product/capture.png"
      structuredData={{ "@context": "https://schema.org", "@type": "SoftwareApplication", name: "Learnflow", url: "https://youwo.ai/learnflow", applicationCategory: "EducationalApplication", operatingSystem: "Web, macOS, iOS", description: meta.description }} />
    <main id="main-content" tabIndex={-1} className="intl-page">
      <section className="quant-wrap intl-hero" aria-labelledby="learnflow-page-title">
        <div><p className="quant-eyebrow">{copy.label}</p><h1 id="learnflow-page-title">Learnflow</h1><p className="quant-lead">{copy.text}</p><a className="quant-button" href="https://learnflow.youwo.ai/">{copy.cta}</a></div>
        <figure><img src="/product/capture.png" width="1492" height="822" alt={copy.alt} decoding="async" /><figcaption>{copy.caption}</figcaption></figure>
      </section>
      <section className="quant-wrap intl-steps" aria-label="Learnflow"><h2>{language === "zh" ? "从记录到理解" : language === "ja" ? "記録から理解へ" : "From capture to understanding"}</h2><div>{copy.features.map((feature, index) => <article key={feature}><span>0{index + 1}</span><h3>{feature}</h3></article>)}</div></section>
    </main>
  </MarketingShell>;
}
